import { render } from "./ContestPage.vue?vue&type=template&id=a4506ef4&scoped=true"
import script from "./Contest.js?vue&type=script&lang=js&external"
export * from "./Contest.js?vue&type=script&lang=js&external"

import "./ContestPage.vue?vue&type=style&index=0&id=a4506ef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4506ef4"]])

export default __exports__